import { TeamCardElementType } from "@/components/TeamCard/TeamCard";
import { TeamGridModuleType } from "@/modules/TeamGrid/TeamGrid";
import { WPClient } from "@/wp/client/WPClient";

/* jscpd:ignore-start */
interface FetchPostsProps {
  page: number;
  postsPerPage: number;
  offset: number;
  locale: string | undefined;
  defaultLocale: string | undefined;
  module: TeamGridModuleType;
}

export const fetchTeams = async ({
  module,
  page,
  postsPerPage,
  offset,
  locale,
  defaultLocale,
}: FetchPostsProps) => {
  const client = new WPClient({ locale, defaultLocale });
  const { type, categories, posts: selectedPosts } = module.team_grid;
  const timestamp = Date.now();
  const postsResult = await client.getPosts({
    type: "team",
    page: page,
    perPage: postsPerPage,
    offset,
    fields: [
      "id",
      "date",
      "link",
      "_embedded",
      "acf.header_team",
      "team_category",
    ],
    ...(type === "team" && {
      includeIds: { ids: selectedPosts || [], keepOrder: true },
    }),
    ...(type === "categories" && {
      includeCategories: [{ category: "team_category", ids: categories || [] }],
    }),
    customParams: {
      filtered: "1", // activate the filter for the team grid
      _ts: timestamp.toString(), // force the cache to be invalidated
    },
  });

  const posts = postsResult.posts.map((post) => {
    const header = post.acf?.header_team;
    return { element: header, url: post.link } as TeamCardElementType;
  });
  return {
    posts,
    totalPosts: postsResult.totalPosts,
  };
};

/* jscpd:ignore-end */
